import { CustomWindow } from './models/customwindow';

declare let window: CustomWindow;

export class General {
  constructor() {}

  static loadImage(imageElement: HTMLImageElement): Promise<HTMLImageElement> {
    if (!imageElement) {
      return Promise.reject();
    }

    return new Promise((resolve, reject) => {
      imageElement.onload = () => {
        resolve(imageElement);
      };

      if (imageElement.complete) {
        resolve(imageElement);
      }

      imageElement.onerror = reject;
    });
  }

  static focusTrap(event: KeyboardEvent, focusableElements: Element[], additionalCondition: boolean | undefined = undefined): void {
    /*
      Events need to be "default-prevented" before they are sent here.
    */
    setTimeout(() => {
      const isTabPressed = event.key === 'Tab';
      if (!isTabPressed || (additionalCondition != undefined && !additionalCondition)) {
        return;
      }

      const filteredFocusableContent = focusableElements.filter((element) => (element as HTMLElement).offsetHeight > 0);

      const currentIndex = filteredFocusableContent.indexOf(event.target as HTMLElement);
      let nextIndex = currentIndex + (event.shiftKey ? -1 : 1);

      if (nextIndex < 0) {
        nextIndex = filteredFocusableContent.length - 1;
      }

      if (nextIndex >= filteredFocusableContent.length) {
        nextIndex = 0;
      }

      (filteredFocusableContent[nextIndex] as HTMLElement).focus();
    });
  }
}

window.addEventListener('CookiebotOnLoad', () => {
  if (!document.body.classList.contains("cookiebot-loaded")) {
    document.body.classList.add("cookiebot-loaded");
  }
});